import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import InfoIcon from 'assets/info.svg';

const defaultTranslations = {
  tr: 'Bu görselde 3D kullanılmıştır',
  'en-US': '3D is used in this image',
  de: 'In diesem Bild wird 3D verwendet',
  ru: 'В этом изображении используется 3D',
};

const ThreeDNotice = ({ className, text, iconClassName, onlyMaldives = true, overlay = false }) => {
  const router = useRouter();
  const { t } = useTranslation('common');
  const locale = router?.locale || 'tr';

  const currentPath = (router?.asPath || '').toLowerCase();
  const isMaldives = currentPath.includes('maldives');

  if (onlyMaldives && !isMaldives) {
    return null;
  }

  const defaultText = defaultTranslations[locale] || defaultTranslations['en-US'] || defaultTranslations.tr;
  const label = text || t('general.$3dNotice', defaultText);
  const isOverlay = overlay || (className && className.includes('absolute'));

  return (
    <div
      className={classNames(
        'three-d-notice flex items-center gap-1.5 font-montserrat text-xs not-italic font-normal leading-5 select-none',
        isOverlay
          ? '!text-white [&>svg]:!fill-white [&>svg]:!stroke-transparent drop-shadow-[0_1px_2px_rgba(0,0,0,0.6)]'
          : 'opacity-75 color-from-bg',
        className,
      )}
    >
      <InfoIcon
        aria-hidden="true"
        className={classNames(isOverlay ? '!fill-white opacity-90' : 'opacity-80', iconClassName)}
      />
      <span>{label}</span>
    </div>
  );
};

ThreeDNotice.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  iconClassName: PropTypes.string,
  onlyMaldives: PropTypes.bool,
  overlay: PropTypes.bool,
};

export default ThreeDNotice;
